export enum EJobDashboardCircleChartType {
    Employees,
    Phases,
    Positions,
    Hours
}